import React from "react";
import { IDSButton } from "@inera/ids-react";
import { useAuth } from "../contexts/AuthContext";

const SessionExpiredModal = () => {
  const {
    sessionExpired,
    sessionExpiringSoon,
    refreshSession,
    dismissExpiryWarning,
  } = useAuth();

  if (!sessionExpired && !sessionExpiringSoon) {
    return null;
  }

  const isExpired = sessionExpired;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          background: "white",
          padding: "2rem",
          borderRadius: "8px",
          maxWidth: "440px",
          width: "90%",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "1rem",
            gap: "0.75rem",
          }}
        >
          <span
            style={{
              fontSize: "1.5rem",
              lineHeight: 1,
            }}
          >
            {isExpired ? "🔒" : "⏱️"}
          </span>
          <h2 className="ids-heading-m" style={{ margin: 0 }}>
            {isExpired
              ? "Sessionen har löpt ut"
              : "Sessionen håller på att löpa ut"}
          </h2>
        </div>

        <p style={{ marginBottom: "1.5rem", color: "var(--ids-palette-neutral-30)" }}>
          {isExpired
            ? "Din inloggning har gått ut. Logga in igen i popup-fönstret för att fortsätta utan att förlora ditt arbete."
            : "Din inloggning håller på att gå ut. Förnya sessionen för att fortsätta utan avbrott."}
        </p>

        <div
          style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}
        >
          {!isExpired && (
            <IDSButton secondary size="m" onClick={dismissExpiryWarning}>
              Stäng
            </IDSButton>
          )}
          <IDSButton size="m" onClick={refreshSession}>
            {isExpired ? "Logga in igen" : "Förnya session"}
          </IDSButton>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
